module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("FOCVT"))).then(() => parcelRequire('1iHdE'));